module.exports = __webpack_public_path__ + "static/Vermarc_Logo_White-486997979ca096637aaaf655cd37f8bd.png";